<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
            >
              查询时间：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-date-picker
              v-model="tableList.tableQuery.search.searchStartDate"
              type="date"
              placeholder="选择开始日期"
              style="width:100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-col>
          <el-col :span="4">
            <el-date-picker
              v-model="tableList.tableQuery.search.searchEndDate"
              type="date"
              placeholder="选择结束日期"
              style="width:100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-col>
          <el-col
            :span="5"
          >
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          :data-total="tableList.tableDataTotal"
          @reloadData="loadTableData(tableList)"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { findOutdepotBillDetailListDataPageByConditionApi, findOutdepotBillDetailListDataPageByUsedStatisticsApi } from '@/api/outdepotBill'
import { loadIndepotBillDetailListDataApi } from '@/api/indepotBill'
export default {
  name: 'MaterialList',
  components: { CustomTable },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    },
    selectItem: {
      type: Object,
      default: null
    },
    viewType: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'material_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: 'desc' // 排序类型 ascending升序 descending降序
          },
          search: {
            schemeId: null,
            receiverId: null,
            materialsId: null,
            searchStartDate: '',
            searchEndDate: ''
          }
        }
      },
      isPaging: true
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.tableList.tableQuery.search = { schemeId: null, receiverId: null, materialsId: null, searchStartDate: '', searchEndDate: '' }
        if (this.viewType === 1) { // 领用明细
          this.tableList.initTableColumn = [
            { prop: 'rowNumber', label: '序号', filterColumn: '', width: 80, },
            { prop: 'outdepotId', label: '出库单号', filterColumn: 'bill.outdepot_id', width: 120 },
            { prop: 'outdepotDateStr', label: '出库日期', filterColumn: 'bill.outdepot_date', width: 120 },
            { prop: 'outdepotTypeStr', label: '出库类型', filterColumn: '(case bill.outdepot_type when 1 then "终端维护" when 2 then "其他" when 3 then "品牌推广" when 4 then "品鉴活动" when 5 then "渠道营销" when 6 then "退库" else "" end)', width: 120 },
            { prop: 'receiver', label: '领用人', filterColumn: 'bill.receiver', width: 120 },
            { prop: 'materialsName', label: '物料名称', filterColumn: 'd.materials_name' },
            { prop: 'unitName', label: '物料单位', filterColumn: 'd.unit_name', width: 120 },
            { prop: 'amount', label: '领用数量', filterColumn: 'd.amount', width: 120, isBetween: true }
          ]
          this.tableList.tableQuery.search.isReceiver = 1
          this.tableList.tableQuery.sort.prop = 'bill.outdepot_date'
        } else if (this.viewType === 2) { // 使用明细
          this.tableList.initTableColumn = [
            { prop: 'rowNumber', label: '序号', filterColumn: '', width: 80, },
            { prop: 'usedDateStr', label: '使用日期', filterColumn: 'db.used_date', width: 120 },
            { prop: 'outdepotTypeStr', label: '出库类型', filterColumn: '(case db.outdepot_type when 1 then "终端维护" when 2 then "其他" when 3 then "品牌推广" when 4 then "品鉴活动" when 5 then "渠道营销" when 6 then "退库" else "" end)', width: 120 },
            { prop: 'usedName', label: '使用对象', filterColumn: 'db.used_name', width: 160 },
            { prop: 'materialsName', label: '物料名称', filterColumn: 'db.materials_name' },
            { prop: 'unitName', label: '物料单位', filterColumn: 'db.unit_name', width: 120 },
            { prop: 'amount', label: '使用数量', filterColumn: 'db.amount', width: 120, isBetween: true }
          ]
          this.tableList.tableQuery.sort.prop = 'db.used_date'
        } else { // 退回明细
          this.tableList.initTableColumn = [
            { prop: 'rowNumber', label: '序号', filterColumn: '', width: 80, },
            { prop: 'indepotDateStr', label: '退回日期', filterColumn: 'bill.indepot_date', width: 120 },
            { prop: 'materialsName', label: '物料名称', filterColumn: 'd.materials_name' },
            { prop: 'unitName', label: '物料单位', filterColumn: 'd.unit_name', width: 120 },
            { prop: 'amount', label: '退回数量', filterColumn: 'd.amount', width: 120, isBetween: true },
            { prop: 'remark', label: '退回备注', filterColumn: 'bill.remark', width: 260 }
          ]
          this.tableList.tableQuery.search.outdepotDetailItemId = this.selectItem.detailIds
          this.tableList.tableQuery.search.indepotType = 2
          this.tableList.tableQuery.sort.prop = 'bill.indepot_date'
        }
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.tableList.tableQuery.search.schemeId = this.selectItem.schemeId
        this.tableList.tableQuery.search.receiverId = this.selectItem.receiverId
        this.tableList.tableQuery.search.materialsId = this.selectItem.materialsId
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.tableList.tableQuery) }
      if (this.viewType === 1) {
        findOutdepotBillDetailListDataPageByConditionApi(pageCondition).then(response => {
          this.tableList.tableLoading = false
          let data = response.data.data ? response.data.data : []
          this.handleData(this.tableList, data)
          this.tableList.tableDataTotal = response.data.recordsTotal
        }).catch()
      } else if (this.viewType === 2) {
        findOutdepotBillDetailListDataPageByUsedStatisticsApi(pageCondition).then(response => {
          this.tableList.tableLoading = false
          let data = response.data.data ? response.data.data : []
          this.handleData(this.tableList, data)
          this.tableList.tableDataTotal = response.data.recordsTotal
        }).catch()
      } else {
        loadIndepotBillDetailListDataApi(pageCondition).then(response => {
          this.tableList.tableLoading = false
          let data = response.data.data ? response.data.data : []
          this.handleData(this.tableList, data)
          this.tableList.tableDataTotal = response.data.recordsTotal
        }).catch()
      }
    },
    // 查询
    searchData () {
      // 重置右键筛选条件
      this.tableList.tableQuery.page = 1
      this.tableList.tableQuery.contextmenuWrap = []
      // 重置排序条件
      if (this.viewType === 1) { // 领用明细
        this.tableList.tableQuery.sort.prop = 'bill.outdepot_date'
      } else if (this.viewType === 2) { // 使用明细
        this.tableList.tableQuery.sort.prop = 'db.used_date'
      } else { // 退回明细
        this.tableList.tableQuery.sort.prop = 'bill.indepot_date'
      }
      this.tableList.tableQuery.sort.order = 'desc'
      this.loadTableData(this.tableList)
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
/>